document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const heading = e.target.closest('footer .footer-content.footer-top-menu .menu__heading');
    if (!heading) return;

    e.preventDefault(); // control <summary> manually

    const details = heading.closest('details');
    const ul = details?.querySelector('.details-content ul');
    if (!details || !ul) return;

    const isOpen = details.hasAttribute('active-menu');

    if (isOpen) {
      // close
      ul.style.maxHeight = '0px';
      details.removeAttribute('active-menu');
    } else {
      // open
      details.setAttribute('active-menu', '');
      ul.style.maxHeight = ul.scrollHeight + 'px';
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const heading = e.target.closest('footer .footer-content.footer-top-menu .group-block h3');
    if (!heading) return;

    e.preventDefault();

    const container = heading.closest('.group-block');
    const parent = heading.parentElement;
    const content = parent.nextElementSibling;

    if (!container || !content) return;

    const isOpen = container.hasAttribute('active-menu');

    if (isOpen) {
      // CLOSE
      content.style.maxHeight =  '228px';
      content.offsetHeight; // force reflow
      content.style.maxHeight = '0px';

      container.removeAttribute('active-menu');
    } else {
      // OPEN
      container.setAttribute('active-menu', '');

      content.style.maxHeight = '0px';
      content.offsetHeight;
      content.style.maxHeight = '228px';
    }

    // Cleanup
    content.addEventListener(
      'transitionend',
      () => {
        if (container.hasAttribute('active-menu')) {
          content.style.maxHeight = 'none';
        }
      },
      { once: true }
    );
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-top-accordion.accordion').forEach(accordion => {
    const details = accordion.querySelectorAll('details');

    details.forEach(detail => {
      detail.querySelector('summary').addEventListener('click', e => {
        e.preventDefault();

        details.forEach(d => d.removeAttribute('open'));
        detail.setAttribute('open', '');
      });
    });
  });
});

/*
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.product-top-accordion accordion-custom')
    .forEach(wrapper => {

      const details = wrapper.querySelector('details');
      if (!details) return;

      const summary = details.querySelector('summary');
      const title = summary?.innerText.trim();

      if (title !== 'DOCUMENTATION') return;

      // Second child = details-content
      const content = details.children[1];
      if (!content || !content.classList.contains('details-content')) {
          wrapper.remove();
          return;
      }

      // Check for documents list
      const hasDocuments = content.querySelector('ul.documents');

      // Remove ONLY this Documentation accordion if empty
      if (!hasDocuments) {
        wrapper.remove();
      }
    });
});
*/

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.product-top-accordion accordion-custom')
    .forEach(wrapper => {

      const details = wrapper.querySelector('details');
      if (!details) return;

      const summary = details.querySelector('summary');
      const title = summary?.innerText.trim();

      if (title?.toLowerCase() !== 'documentation') return;

      let content = null;

      const nextEl = details.nextElementSibling;
      if (nextEl && nextEl.classList.contains('details-content')) {
        content = nextEl;
      }

      if (!content) {
        const insideContent = details.querySelector('.details-content');
        if (insideContent) {
          content = insideContent;
        }
      }

      if (!content) {
        wrapper.remove();
        return;
      }

      const hasDocuments = content.querySelector('ul.documents');

      if (!hasDocuments) {
        wrapper.remove();
      }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const moreBtn = document.getElementById('more');
  const lessBtn = document.getElementById('less');
  const para = document.getElementById('para');

  if (!moreBtn || !lessBtn || !para) return;

  moreBtn.addEventListener('click', function (e) {
    e.preventDefault();
    para.style.display = 'block';
    lessBtn.style.display = 'inline-block';
    moreBtn.style.display = 'none';
  });

  lessBtn.addEventListener('click', function (e) {
    e.preventDefault();
    para.style.display = 'none';
    lessBtn.style.display = 'none';
    moreBtn.style.display = 'inline-block';
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".show_all_subcategories")
    .forEach(function(toggle) {
      const wrapper = toggle.nextElementSibling;
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        const isOpen = wrapper.classList.contains("is-open");
        if (!isOpen) {
          wrapper.classList.add("is-open");
          const fullHeight = wrapper.scrollHeight;
          wrapper.style.height = "0px";
          requestAnimationFrame(() => {
            wrapper.style.height = fullHeight + "px";
          });
          toggle.classList.add("open");
          toggle.setAttribute("aria-expanded", "true");
          wrapper.addEventListener("transitionend", function handler() {
            wrapper.style.height = "auto";
            wrapper.removeEventListener("transitionend", handler);
          });
        } else {
          const fullHeight = wrapper.scrollHeight;
          wrapper.style.height = fullHeight + "px";
          requestAnimationFrame(() => {
            wrapper.style.height = "0px";
          });
          wrapper.classList.remove("is-open");
          toggle.classList.remove("open");
          toggle.setAttribute("aria-expanded", "false");
        }
      });
  });
});

const clearBtn = document.getElementById('clear-cart-btn');
if(clearBtn) {
  clearBtn.addEventListener('click', function () {
    if (confirm("Are you sure you want to remove all items from your cart?")) {
      fetch('/cart/clear.js', {
        method: 'POST'
      }).then(() => {
        window.location.reload();
      });
    }
  });
}

document.addEventListener('click', function (e) {
  const star = e.target.closest('.jdgm-widget.jdgm-preview-badge');
  if (!star) return;

  e.preventDefault();

  const review = document.querySelector('#judgeme_product_reviews');
  if (!review) return;

  const bottomAccordion = review.closest('accordion-custom');
  const reviewDetails = bottomAccordion?.querySelector('details');
  const bottomContainer = review.closest('.product-bottom-accordion');

  bottomContainer?.querySelectorAll('details').forEach(d => {
    if (d !== reviewDetails) {
      d.removeAttribute('open');
    }
  });

  if (reviewDetails && !reviewDetails.open) {
    reviewDetails.open = true;
  }

  setTimeout(() => {
    review.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, 300);

}, true);

/* Terms & condition agreement on Cart page & Minicart: Start */
function initTermsCheckbox() {
    const checkoutButton = document.getElementById("checkout");
    if (!checkoutButton) return;

    const checkbox =
        document.getElementById("cart-terms-checkbox") ||
        document.getElementById("minicart-terms-checkbox");

    if (!checkbox) return;

    // Restore previous state
    const accepted = localStorage.getItem("termsAccepted") === "true";

    checkbox.checked = accepted;
    checkoutButton.disabled = !accepted;

    // Prevent duplicate checkbox event binding
    if (!checkbox.dataset.initialized) {
        checkbox.dataset.initialized = "true";
        checkbox.addEventListener("change", function () {
            localStorage.setItem("termsAccepted", this.checked);
            checkoutButton.disabled = !this.checked;
        });
    }

    // Prevent duplicate checkout button event binding
    if (!checkoutButton.dataset.initialized) {
        checkoutButton.dataset.initialized = "true";
        checkoutButton.addEventListener("click", function (e) {

            if (!checkbox.checked) {
                e.preventDefault();
                e.stopImmediatePropagation();
                alert("Please accept the Privacy Policy and Terms of Service before proceeding to checkout.");
                checkoutButton.disabled = true;
                return false;
            }

        });
    }
}

document.addEventListener("DOMContentLoaded", initTermsCheckbox);

let reopenDrawer = false;

document.addEventListener("click", async function(e){
    const link = e.target.closest(".policy-link");

    if(!link) return;

    e.preventDefault();

    const drawer = document.querySelector("cart-drawer-component");

    if (drawer?.refs?.dialog?.open) {
        reopenDrawer = true;
        drawer.close();
    }

    const modal = document.getElementById("policy-modal");
    modal.classList.add("open");

    document.getElementById("policy-title").textContent =
        link.dataset.title;

    const container = document.getElementById("policy-content");
    container.innerHTML = "Loading...";

    const response = await fetch(link.dataset.url);
    const html = await response.text();

    const doc = new DOMParser().parseFromString(html, "text/html");

    const policy = doc.querySelector(".shopify-policy__container");

    if (policy) {
        // Remove duplicate heading
        policy.querySelector("h1, h2")?.remove();

        // Optional: Remove "Last updated" text
        const firstParagraph = policy.querySelector("p");
        if (
            firstParagraph &&
            firstParagraph.textContent.trim().startsWith("Last updated")
        ) {
            firstParagraph.remove();
        }

        container.innerHTML = policy.innerHTML;
    } else {
        container.innerHTML = "Unable to load content.";
    }
});

document.querySelector(".policy-close").onclick = closePolicy;
document.querySelector(".policy-overlay").onclick = closePolicy;

function closePolicy() {
  document.getElementById("policy-modal").classList.remove("open");

  if (reopenDrawer) {

      requestAnimationFrame(() => {
          document.querySelector("cart-drawer-component")?.open();
      });

      reopenDrawer = false;
  }
}

/* Terms & condition agreement on Cart page & Minicart: End */